import { capitalDesignTokens } from '@opengov/capital-mui-theme';

const { semanticColors, foundations } = capitalDesignTokens;

export const INACTIVE_MERGE_TAGS_BANNER_CLASS = 'inactive-merge-tags-banner';

const C = `.${INACTIVE_MERGE_TAGS_BANNER_CLASS}`;

export const inactiveStoryMergeTagsBannerCss = `
${C} {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  margin-bottom: 8px;
  padding: 16px;
  border: 1px solid ${foundations.colors.yellow900};
  border-radius: 4px;
  background-color: ${foundations.colors.yellow50};
  color: ${semanticColors.foreground.primary};
  font-size: 14px;
  line-height: 1.43;
}

/* MUI sizes every icon purely through CSS — the SVG carries no width/height
   attributes. With no rule at all the browser falls back to the sprite's
   intrinsic size and the severity icon fills the whole banner. */
${C} .MuiSvgIcon-root {
  width: 1em;
  height: 1em;
  flex-shrink: 0;
  font-size: inherit;
  fill: currentColor;
  user-select: none;
}

${C} .MuiSvgIcon-fontSizeSmall {
  font-size: 20px;
}

${C} .MuiAlert-icon {
  display: flex;
  align-items: center;
  margin-right: 12px;
  color: ${foundations.colors.yellow900};
  font-size: 32px;
}

${C} .MuiAlert-message {
  width: 100%;
  min-width: 0;
  padding: 0;
  overflow: hidden;
}

${C} .MuiAlert-action {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 0 8px;
  color: ${semanticColors.foreground.secondary};
}

${C} .MuiAlert-action .MuiIconButton-root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 0;
  border-radius: 50%;
  background: none;
  color: inherit;
  cursor: pointer;
  font-size: 24px;
}

${C} .MuiAlert-action .MuiIconButton-root:hover {
  background-color: ${semanticColors.interaction.hoverLight};
}

${C}__header {
  margin: 0 0 4px;
  font-weight: ${foundations.typography.fontWeight.medium};
}

/* The "Remove all" action and each field-tag jump link are <button>s so they stay
   keyboard-operable; these rules strip the native button chrome back to link. */
${C}__link {
  display: inline-flex;
  max-width: 100%;
  padding: 0;
  border: none;
  background: none;
  color: ${semanticColors.foreground.action};
  cursor: pointer;
  font: inherit;
  text-align: left;
  text-decoration: underline;
}

${C}__tag-link {
  width: 100%;
}

${C}__show-more-container {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

${C}__show-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  color: ${semanticColors.foreground.action};
  cursor: pointer;
  font: inherit;
  text-decoration: none;
}

${C}__show-more:hover {
  text-decoration: underline;
}
`;
